<template>
  <FormContainer withoutDivider>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_36"
          v-model="referenceProjetModel"
          label="N° référence projet"
          :required="meta.contrat?.referenceProjet?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.referenceProjet?.$messageErreurDirty!"
          :maxlength="15"
          hint="15 caractères maximum"
          help="Si la formation est éligible à un cofinancement, merci d'indiquer la référence du projet"
          deletable
          :readonly
          class="col-9 col-md-18 col-sm-36"
        ></WrapperInput>
        <WrapperInput
          id="field_37"
          v-model="referenceInterneEntrepriseModel"
          label="N° référence interne de l’entreprise"
          :required="meta.contrat?.referenceInterneEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.referenceInterneEntreprise?.$messageErreurDirty!"
          hint="30 caractères maximum"
          :maxlength="30"
          deletable
          :readonly
          class="col-9 col-md-18 col-sm-36"
        ></WrapperInput>

        <WrapperInput
          v-if="estReservation"
          id="field_38"
          v-model="nombreContratsModel"
          :required="meta.contrat?.nombreContrats?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.nombreContrats?.$messageErreurDirty!"
          label="Nombre de contrats"
          help="Entre 1 et 20 contrats"
          :readonly
          class="col-9 col-md-18 col-sm-36"
          deletable
        ></WrapperInput>

      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          v-if="meta.contrat?.parcoursPTP?.$status !== PropertyStatus.NotPresent"
          id="field_parcoursPtp"
          v-model="parcoursPtpModel"
          label="Parcours PTP"
          :required="meta.contrat?.parcoursPTP?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.parcoursPTP?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          help="Parcours Projet de Transition Professionnelle"
          class="col-9 col-md-18 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import { DEMANDE_STORE, FormContainer } from '@/features/interface/demande/shared'
import { OuiOuNon } from '@/features/interface/shared/tools'
import WrapperToggleSwitch from '@designSystem/components/wrapper/toggleSwitch/WrapperToggleSwitch.vue'
import { storeToRefs } from 'pinia'
import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
  const { setupFieldWithKey } = store
  const { meta, readonly, estReservation } = storeToRefs(store)

  const referenceProjetModel = setupFieldWithKey<string>('contrat.referenceProjet', true)
  const referenceInterneEntrepriseModel = setupFieldWithKey<string>('contrat.referenceInterneEntreprise', true)
  const nombreContratsModel = setupFieldWithKey<string>('contrat.nombreContrats', true)
  const parcoursPtpModel = setupFieldWithKey<string>('contrat.parcoursPTP', true)
</script>


